import React from "react";
import { observer } from "mobx-react";
import { compose } from "recompose";

import withStores from "@framework/src/libs/withStores";
import withStyles from "@framework/src/libs/withStyles";

import useStores from "@hooks/useStores";

import Dialog from "@material-ui/core/Dialog";
import Hidden from "@material-ui/core/Hidden";

import { styles, stores } from "./.config";

const ProSignupFunnel = compose(
	withStyles(styles),
	withStores(stores),
	observer
)(() => {
	const { proSignupFunnelModalStore: store, proSignupFunnelStore } =
		useStores();

	return (
		<React.Fragment>
			<Hidden xsDown>
				<Dialog
					scroll={"body"}
					fullScreen={false}
					fullWidth={true}
					maxWidth={"sm"}
					open={store.show}
					onClose={() => store.onClose()}
					aria-labelledby="dialog-title"
				>
					<proSignupFunnelStore.Component />
				</Dialog>
			</Hidden>
			<Hidden smUp>
				<Dialog
					scroll={"paper"}
					fullScreen={true}
					fullWidth={true}
					maxWidth={"sm"}
					open={store.show}
					onClose={() => store.onClose()}
					aria-labelledby="dialog-title"
				>
					<proSignupFunnelStore.Component />
				</Dialog>
			</Hidden>
		</React.Fragment>
	);
});

export default ProSignupFunnel;
